import { render, staticRenderFns } from "./LateralScreens.vue?vue&type=template&id=d53b917a&"
import script from "./LateralScreens.vue?vue&type=script&lang=js&"
export * from "./LateralScreens.vue?vue&type=script&lang=js&"
import style0 from "./LateralScreens.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports